module.exports = __webpack_public_path__ + "media/images/icon_search_btn_save-7017aae45285fad2fd2c19b06c6c72b5.png";